'use client';

import { useEffect } from 'react';
import { useLanguage, LOCALE_BCP47 } from '@/i18n/LanguageContext';

/**
 * Updates the html element's lang and dir attributes when the user's locale changes.
 * Render once at the root layout level.
 */
export default function HtmlLangUpdater() {
  const { locale, isRTL } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = LOCALE_BCP47[locale];
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [locale, isRTL]);

  return null;
}
